<template>
<div class="w-100 d-flex justify-content-center">
    <modal name="modal-alert"
            :width="275"
            class="modal-alert"
            :clickToClose="false"
            >
            <span class="warning-icon"></span>
            <p class="center">{{text}}</p>
            
            <div class="center">
            <button class="submit" v-on:click="$modal.hide('modal-alert')">Okay</button>
            </div>
    </modal>
</div>
</template>

<script>
    
export default {

        mixins:[],
        props: [],
        inject: [],
        data : function(){       
            return {

                text:''


            };
        },
        computed: {

            
        },
        watch :{

            

        },
        created : function(){
            this.$bus.$on('show_modal_alert', this.showChickenPopup);
            this.$bus.$on('hide_modal_alert', this.hideChickenPopup);

        },
        beforeDestroy() {
            this.$bus.$off('show_modal_alert', this.showChickenPopup);
            this.$bus.$off('hide_modal_alert', this.hideChickenPopup);
        },
        mounted : function ()
        {
        },
        destroyed () {
        },
        methods:{
            /*
            * Show me the chicken
            * @param bool forced - true if this popup was summoned on user CTA (like 'delete') 
            * rather than navigation away from an unsaved form
            */

            showChickenPopup(text)
            {
                this.text = text;
                this.$modal.show('modal-alert');
            },

            /*
            * Destroy the chicken
            */

            hideChickenPopup()
            {
                this.text = '';
                this.$modal.hide('modal-alert');
            }
        }
    }
</script>

<style>

.modal-alert{
    text-align: center;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-shadow: none;
    border-radius: 10px;
    padding: 20px;
}

.center{
    text-align: center;
    padding-left: 6px;
    padding-right: 6px;
}
.warning-icon{
    background-image: url("../assets/warning.svg");
    background-repeat: no-repeat;
    background-size:100%;
    height: 50px;
    width: 50px;
    display: block;
    margin: 45px auto;
}
.submit{
    margin-top: 20px;
}


</style>